module.exports = __webpack_public_path__ + "static/img/icon_btn2.c393a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_btn2.png
// module id = TbcM
// module chunks = 0